var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.6,
    height: 67.7,
    viewBox: "0 0 67.6 67.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.91,
    y1: 57.74,
    x2: 57.69,
    y2: 9.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f48a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,67.7A33.85,33.85,0,1,0,0,33.8,33.82,33.82,0,0,0,33.8,67.7Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.56,38.66l12.1-12.1A1.75,1.75,0,1,1,41.14,29L29,41.14a1.75,1.75,0,1,1-2.48-2.48Zm22.58-20.2a10.39,10.39,0,0,0-14.6,0l-5.1,5.3A1.75,1.75,0,0,0,32,26.21L37,20.94a6.8,6.8,0,0,1,9.62,9.62l-5.2,5.2a1.75,1.75,0,0,0,2.48,2.48l5.2-5.2a10.41,10.41,0,0,0,0-14.58Zm-13.38,23-5.2,5.2A6.8,6.8,0,0,1,20.94,37l5.2-5.2a1.75,1.75,0,0,0-2.48-2.48l-5.2,5.2A10.31,10.31,0,0,0,33,49.14l5.2-5.2a1.75,1.75,0,0,0-2.48-2.48Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.6646e968c7cce72c62da970d9350eb2d.svg";
export { ForwardRef as ReactComponent };